var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 16,
  viewBox: "0 0 20 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-heart",
  "data-name": "Icon feather-heart",
  d: "M20.781,5.912a5.6,5.6,0,0,0-7.444,0l-1.014.93-1.014-.93a5.605,5.605,0,0,0-7.444,0,4.551,4.551,0,0,0,0,6.828l1.014.93L12.323,20.5l7.444-6.828,1.014-.93a4.55,4.55,0,0,0,0-6.828Z",
  transform: "translate(-2.323 -4.497)",
  fill: "#f6222c"
})));
export default __webpack_public_path__ + "static/media/internalfilledheartican.2c806cdc.svg";
export { SvgComponent as ReactComponent };